var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('layout-nav'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('layout-footer'),_vm._v(" "),_c('layout-aside')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }